'use strict';

function isValidationError(error) {
    return (typeof error === 'object' && Object.hasOwn(error, 'validationPointers'));
}

exports.isValidationError = isValidationError;
//# sourceMappingURL=validationErrors.js.map
